/**
 * Published Fixed New Teeth treatment minimums and terms.
 * Source: TDA Fixed Full-Arch Patient Pricing Sheet v8.2 and
 * TDA Staff Full-Arch Briefing v8.2 (October 13, 2026).
 */
export const FULL_ARCH_PRICING_PATH = '/fixed-new-teeth#pricing';
export const FULL_ARCH_PRICING_URL = `https://trinitydentalarts.com${FULL_ARCH_PRICING_PATH}`;

const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const usd = (amount) => dollarFormatter.format(amount);

export const FULL_ARCH_TIERS = [
  {
    id: 'fixed-new-teeth',
    name: 'Fixed New Teeth',
    pricePerArch: 18900,
    priceBothArches: 35900,
    design: 'Standard design features',
    tryIns: 'One try-in and one revision',
    warrantyYears: 1,
    maintenance: 'A maintenance plan is required to keep the warranty active.',
  },
  {
    id: 'signature',
    name: 'Fixed New Teeth Signature',
    pricePerArch: 22900,
    priceBothArches: 42900,
    design: 'Custom esthetic design. Plan the tooth shape, shade and smile line with us.',
    tryIns: 'Two try-ins and two revisions',
    warrantyYears: 5,
    maintenance: 'A maintenance plan is required to keep the warranty active.',
  },
  {
    id: 'premium',
    name: 'Fixed New Teeth Premium',
    pricePerArch: 27900,
    priceBothArches: 52900,
    design: 'Fully custom teeth with layered shade, surface detail and gum contour.',
    tryIns: 'Up to three try-ins and up to three revisions',
    warrantyYears: 10,
    maintenance: 'First year of maintenance included. Ongoing requirements are in the written warranty.',
  },
];

export const FULL_ARCH_PER_ARCH_FROM = Math.min(...FULL_ARCH_TIERS.map((tier) => tier.pricePerArch));
export const FULL_MOUTH_FROM = Math.min(...FULL_ARCH_TIERS.map((tier) => tier.priceBothArches));
export const fullArchFromLabel = () => `from ${usd(FULL_ARCH_PER_ARCH_FROM)} per arch`;

export const FULL_ARCH_INCLUSIONS = [
  '3D planning with CBCT imaging',
  'Implant surgery with the extractions and grafting in your written plan',
  'IV sedation by our anesthesia team',
  'Same-day fixed temporary teeth when clinically appropriate',
  'Zirconia final teeth made in our in-house lab',
  'Follow-up visits through delivery of your final teeth',
];

export const FULL_ARCH_INCLUSION_SUMMARY =
  'Every level includes 3D planning with CBCT imaging, implant surgery with planned extractions and grafting, IV sedation, same-day fixed temporary teeth when clinically appropriate, in-house zirconia final teeth, and follow-up through delivery of the final teeth.';

export const FULL_ARCH_WARRANTY_SUMMARY =
  'Every level includes a written warranty: 1 year for Fixed New Teeth, 5 years for Signature, and 10 years for Premium. The warranty starts when your final teeth, made after your approval, are delivered. Maintenance requirements, coverage and exclusions are in the written warranty. Fixed New Teeth and Signature require a maintenance plan. Premium includes the first year of maintenance.';

export const FULL_ARCH_FINANCING =
  'Financing through CareCredit, Cherry and Proceed is subject to credit approval. The lender sets the terms.';

export const FULL_ARCH_MINIMUM_NOTICE =
  'Each fee shown is a minimum fee only for that level of treatment. Your exact fee is confirmed in writing after examination and depends on your diagnosis, implant count, any extractions or grafting, and the level you choose. Fees apply to full-arch implant treatment including CDT D6010 and D6114/D6115.';

export const FLORIDA_FREE_OFFER_NOTICE =
  'THE PATIENT AND ANY OTHER PERSON RESPONSIBLE FOR PAYMENT HAS A RIGHT TO REFUSE TO PAY, CANCEL PAYMENT, OR BE REIMBURSED FOR PAYMENT FOR ANY OTHER SERVICE, EXAMINATION, OR TREATMENT THAT IS PERFORMED AS A RESULT OF AND WITHIN 72 HOURS OF RESPONDING TO THE ADVERTISEMENT FOR THE FREE, DISCOUNTED FEE, OR REDUCED FEE SERVICE, EXAMINATION, OR TREATMENT.';